import React from "react";
import { Outlet, Route } from "react-router-dom";

import { AppRoute } from "./types";

export const renderRoutes = (routes: AppRoute[]) =>
  routes.map(({ path, index, element, children }) => {
    const key = path ?? (index ? "index" : "no-path");

    if (index) {
      return <Route key={key} index element={element ?? null} />;
    }

    const routeElement =
      children != null ? element ?? <Outlet /> : element ?? null;

    return (
      <Route key={key} path={path} element={routeElement}>
        {children && renderRoutes(children)}
      </Route>
    );
  });
